(function () {
  'use strict';

  const SELECTORS = {
    productsGrid: '[data-products-grid]',
    collectionLoop: '#CollectionLoop',
    pagination: '.pagination-custom',
    paginationNext: 'a.pagination-custom__next',
    sectionType: '[data-section-type="collection"]',
  };

  class InfiniteScroll {
    constructor(productsGrid) {
      this.productsGrid = productsGrid;
      this.grid = productsGrid.querySelector(SELECTORS.collectionLoop);
      this.pagination = productsGrid.querySelector(SELECTORS.pagination);
      this.isLoading = false;
      this.observer = null;

      if (!this.grid || !this.pagination) return;
      this.init();
    }

    init() {
      // Keep pagination in DOM flow (for IntersectionObserver) but hide visually
      this.pagination.style.opacity = '0';
      this.pagination.style.pointerEvents = 'none';
      this.pagination.setAttribute('aria-hidden', 'true');

      this.observer = new IntersectionObserver(
        (entries) => this.handleIntersection(entries),
        { rootMargin: '0px 0px 400px 0px' }
      );

      this.observer.observe(this.pagination);
    }

    handleIntersection(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.isLoading) {
          this.loadMore();
        }
      });
    }

    loadMore() {
      const nextLink = this.pagination.querySelector(SELECTORS.paginationNext);
      if (!nextLink) {
        this.destroy();
        return;
      }

      this.isLoading = true;
      this.productsGrid.classList.add('is-loading');

      fetch(nextLink.href)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const newDoc = parser.parseFromString(html, 'text/html');

          // Append new products
          const newGrid = newDoc.querySelector(SELECTORS.collectionLoop);
          if (newGrid) {
            Array.from(newGrid.children).forEach((item) => {
              this.grid.appendChild(item);
            });
          }

          // Update pagination to point to next page
          const newPagination = newDoc.querySelector(SELECTORS.pagination);
          if (newPagination) {
            this.pagination.innerHTML = newPagination.innerHTML;
          } else {
            this.destroy();
          }

          this.isLoading = false;
          this.productsGrid.classList.remove('is-loading');
        })
        .catch(() => {
          this.isLoading = false;
          this.productsGrid.classList.remove('is-loading');
        });
    }

    destroy() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.pagination) {
        this.pagination.style.display = 'none';
      }
    }
  }

  function initInfiniteScroll(container) {
    const productsGrid = container.querySelector(SELECTORS.productsGrid);
    if (!productsGrid) return;

    // Destroy previous instance if any
    if (productsGrid._infiniteScroll) {
      productsGrid._infiniteScroll.destroy();
    }

    productsGrid._infiniteScroll = new InfiniteScroll(productsGrid);
  }

  function setup() {
    document.querySelectorAll(SELECTORS.sectionType).forEach((container) => {
      initInfiniteScroll(container);

      // Re-init when collection-filters-form replaces the products grid content
      const productsGrid = container.querySelector(SELECTORS.productsGrid);
      if (productsGrid && !productsGrid._infiniteScrollMutation) {
        productsGrid._infiniteScrollMutation = new MutationObserver(() => {
          initInfiniteScroll(container);
        });
        productsGrid._infiniteScrollMutation.observe(productsGrid, {
          childList: true,
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
